export default __webpack_public_path__ + "static/media/branding-semibolditalic-webfont.66339eaf.woff";